const WORK_STYLES_LINK = "http://help.teaming.com/en/articles/6015460-understanding-teaming-s-disc-work-styles";

export default {
	heading: "Individual Work Styles",
	description: "Click or tap an individual’s name to see a full breakdown of their workstyle.",
	discDescription: `Opre’s work style reports use the DiSC personality assessment. <a href="${ WORK_STYLES_LINK }" target="_blank" title="Learn more about DiSC">Learn more about DiSC</a>.`,
};
